import $ from "cash-dom";

const component = (function () {
    $(document).ready(function () {
        $("[data-action='legal-notice']").on("click", function (_e) {
            _e.preventDefault();
            $("#legal-notice").addClass("on").removeClass("pointer-none");
            $("#legal-notice [data-action='close']").removeClass("pointer-none");
            $("body").addClass("locked");
        });

        $("#legal-notice [data-action='close']").on("click", function () {
            $("#legal-notice").addClass("pointer-none").removeClass("on");
            $("#legal-notice [data-action='close']").addClass("pointer-none");
            $("body").removeClass("locked");
        });

        $("[data-action='privacy']").on("click", function (_e) {
            _e.preventDefault();
            $("#privacy").addClass("on").removeClass("pointer-none");
            $("#privacy [data-action='close']").removeClass("pointer-none");
            $("body").addClass("locked");
        });

        $("#privacy [data-action='close']").on("click", function () {
            $("#privacy").addClass("pointer-none").removeClass("on");
            $("#privacy [data-action='close']").addClass("pointer-none");
            $("body").removeClass("locked");
        });

        $(window).on("keydown", function (e) {
            if (e.key == "Escape") {
                $("#legal-notice, #privacy").addClass("pointer-none").removeClass("on");
                $("#legal-notice [data-action='close'], #privacy [data-action='close']").addClass("pointer-none");
                $("body").removeClass("locked");
            }
        });
    });
})();

export default component;
